/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_LinkInputs */

const th_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด →`)
};

const en_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open →`)
};

const ja_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く →`)
};

const zh_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 →`)
};

const es_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir →`)
};

const pt_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir →`)
};

const id_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka →`)
};

const fr_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir →`)
};

const tl_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan →`)
};

const vi_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở →`)
};

const ko_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기 →`)
};

const de_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen →`)
};

const ru_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть →`)
};

const tr_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç →`)
};

const it_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri →`)
};

const pl_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz →`)
};

const uk_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити →`)
};

const hi_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें →`)
};

const ar_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح ←`)
};

const ms_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka →`)
};

const bn_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খুলুন →`)
};

const zh_tw2_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟 →`)
};

const zh_hk2_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟 →`)
};

const ur_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھولیں ←`)
};

const fa_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باز کردن ←`)
};

const sw_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua →`)
};

const nl_open_link = /** @type {(inputs: Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen →`)
};

/**
* | output |
* | --- |
* | "Open →" |
*
* @param {Open_LinkInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const open_link = /** @type {((inputs?: Open_LinkInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_LinkInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_open_link(inputs)
	if (locale === "ja") return ja_open_link(inputs)
	if (locale === "zh") return zh_open_link(inputs)
	if (locale === "es") return es_open_link(inputs)
	if (locale === "pt") return pt_open_link(inputs)
	if (locale === "id") return id_open_link(inputs)
	if (locale === "fr") return fr_open_link(inputs)
	if (locale === "tl") return tl_open_link(inputs)
	if (locale === "vi") return vi_open_link(inputs)
	if (locale === "ko") return ko_open_link(inputs)
	if (locale === "de") return de_open_link(inputs)
	if (locale === "ru") return ru_open_link(inputs)
	if (locale === "tr") return tr_open_link(inputs)
	if (locale === "it") return it_open_link(inputs)
	if (locale === "pl") return pl_open_link(inputs)
	if (locale === "uk") return uk_open_link(inputs)
	if (locale === "hi") return hi_open_link(inputs)
	if (locale === "ar") return ar_open_link(inputs)
	if (locale === "ms") return ms_open_link(inputs)
	if (locale === "bn") return bn_open_link(inputs)
	if (locale === "zh-TW") return zh_tw2_open_link(inputs)
	if (locale === "zh-HK") return zh_hk2_open_link(inputs)
	if (locale === "ur") return ur_open_link(inputs)
	if (locale === "fa") return fa_open_link(inputs)
	if (locale === "sw") return sw_open_link(inputs)
	if (locale === "nl") return nl_open_link(inputs)
	return en_open_link(inputs)
});